import React from "react";
import MaterialTable from "material-table";
import { withStyles, Paper } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import CustomMTableHeader from "../../../../../../Component/Table/CustomMTableHeader";
import CustomMTableRow from "../../../../../../Component/Table/CustomTableRow";
import CustomMTableCell from "../../../../../../Component/Table/CustomMTableCell";
import {
  tableIcons,
  tableStyle,
  tableOptions,
} from "../../../../../../Component/Table/tableCommonStyles";
import { TableHeader } from "./tableHeader";
import { styles } from "./styles";
import { useTranslation } from "react-i18next";

const CountryBasicDataTable = (props) => {
  const {
    classes,
    countries,
    loading,
    onNewAction,
    onUpdateRecord,
    canAdd,
    canEdit,
  } = props;
  const { t } = useTranslation();

  return (
    <div className={classes.tableWrapper}>
      <MaterialTable
        title=""
        style={tableStyle}
        icons={tableIcons}
        elevation="0"
        options={{
          ...tableOptions,
          toolbar: true,
          search: true
        }}
        actions={[
          canAdd && {
            icon: () => <AddIcon />,
            tooltip: t('labels.country.basicInformation.countryTable.actions.addCountry'),
            onClick: onNewAction,
            isFreeAction: true
          },
          canEdit && {
            icon: () => <EditIcon />,
            tooltip: t('labels.country.basicInformation.countryTable.actions.editCountry'),
            onClick: onUpdateRecord
          }
        ]}
        data={countries}
        localization={{
          header: {
            actions: t('labels.common.table.actions')
          },
          toolbar: {
            searchPlaceholder: t('labels.common.search')
          },
          body: {
            emptyDataSourceMessage: t('labels.common.table.noRecordsFound'),
            editTooltip: t('labels.common.edit'),
            editRow: {
              saveTooltip: t('labels.common.save'),
              cancelTooltip: t('labels.common.cancel')
            }
          }
        }}
        columns={TableHeader(t)}
        isLoading={loading}
        components={{
        Container: (props) => <Paper component="div" {...props} elevation={0} />,
        Header: (props) => <CustomMTableHeader {...props} />,
        Row: (props) => <CustomMTableRow {...props} />,
        Cell: (props) => <CustomMTableCell {...props} />,
      }}
      />
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(CountryBasicDataTable);